import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { fetchData } from "../../../Cpanel/Components/Utilities";
import { useNavigate } from "react-router-dom";

export const GoldPlan = () => {
  const [userStatus, setUserStatus] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    fetchData("goldplan", bodyFormData, handleApiResponse);
  }, []);
  const handleApiResponse = (data) => {
    setUserStatus(data);
  };
  console.log(userStatus);

  const handleInsInquiryResponse = (data) => {
    console.log(data);
  };
  const handleCheckinstallment =() => {
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    fetchData("insinquiry", bodyFormData, handleInsInquiryResponse);
  }

  return (
    <div className=" m-2">
      <p className="p-2 lh-2 text-center">
        سطح کاربری شما <strong className="bg-gold">طلایی</strong> می باشد می
        توانید یکی از روش های زیر را برای ارتقای سطح خود انتخاب کنید.
      </p>
      <div className="d-flex justify-content-center gap-3 flex-wrap align-items-center text-center">
        <div className=" rounded p-4 text-center plan-card ">
          <h4>پرداخت نقدی </h4>
          <p>
            <strong>
              مبلغ بیمه نامه(با تخفیف):{" "}
              {userStatus?.finalInsPrice?.toLocaleString()}
            </strong>
          </p>
          <p>
            <strong>پرداختی بابت بیمه نامه:</strong>
          </p>
          <p>
            <strong>سکه های موجود:</strong>
          </p>
          <p>
            <strong>قابل پرداخت:</strong>
          </p>
          <button
            className="btn btn-success"
            // onClick={() => navigate("/lifeInsurance/insurancesteps")}
            onClick={()=> handleCheckinstallment()}
          >
            پرداخت
          </button>
        </div>

        <div className=" p-4 rounded text-center plan-card ">
          <h4>پرداخت اقساطی</h4>
          <p>
            <strong>مبلغ بیمه نامه(با تخفیف): 22223</strong>
          </p>
          <p>
            <strong>پرداختی بابت بیمه نامه:</strong>
          </p>
          <p>
            <strong>سکه های موجود:</strong>
          </p>
          <p>
            <strong>قابل پرداخت:</strong>
          </p>
          <button
            className="btn btn-primary"
            onClick={() => navigate("/lifeInsurance/insurancesteps")}
          >
            پرداخت
          </button>
        </div>
      </div>

      <>
        <div>جدول اقساط</div>
      </>
    </div>
  );
};
